import React, { FC } from "react";
import classNames from "classnames";
import { BlockBody } from "@app/components/common/block-body/BlockBody";
import { RichText } from "@app/components/base-page/models";
import { useFormatDate } from "@app/hooks";
import { CategoryLabel } from "@app/components";

type Props = {
  title: string;
  date: string;
  categoryId: string;
  body: RichText;
};

export const Body: FC<Props> = ({ title, date, categoryId, body }) => {
  const formattedDate = useFormatDate(date);

  return (
    <div className="grid grid-cols-12 content-center">
      <div
        className={classNames("col-span-12", "md:col-span-7 md:col-start-2")}
      >
        <h1
          className={classNames(
            "mb-2.5 text-medium text-base-100",
            "lg:mb-15 lg:text-large",
            "xl:text-xx-large",
          )}
        >
          {title}
        </h1>
        <div className="mb-5 text-base-400 md:hidden">
          <div className="mb-3">{formattedDate}</div>
          <CategoryLabel categoryId={categoryId} />
        </div>

        <div
          className={classNames(
            "prose text-regular text-base-400 prose-headings:text-primary-content",
          )}
        >
          <BlockBody richText={body} />
        </div>
      </div>

      <div className="md:col-span-3">
        <div className="mt-3 hidden text-right text-medium text-base-400 md:block">
          <div className="mb-5">{formattedDate}</div>
          <CategoryLabel categoryId={categoryId} />
        </div>
      </div>
    </div>
  );
};
